import React, { useEffect, useState } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useDispatch, useSelector } from 'react-redux';
import { updateGritData } from '../../redux/graphs';
import Result from '../Result';

/**
 * Ref: https://www.highcharts.com/demo/highcharts/column-placement
 * 
 */


const Grit = () => {
  const dispatch = useDispatch();

  const grit = useSelector((state) => state.graphs.grit);
  const [options, setOptions] = useState([]);
  // - - - - - - - - - - - - - - - - - - - - - - - - -
  useEffect(() => {
    dispatch(
      updateGritData()
    );
  }, []);

  useEffect(() => {
    setOptions (
      {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Grit',
          align: 'left'
        },
        subtitle: {
          text: 'This measures your self reported levels of interest in and effort towards long term goals or higher purposes',
          align: 'left',
        },
        xAxis: {
          categories: grit.x_labels
        },
        yAxis: [
          { min: 0, title: { text: 'Effort' } }, 
          { title: { text: 'Intrest' }, opposite: true }
        ],
        legend: { shadow: false },
        tooltip: {
          shared: true
        },
        plotOptions: {
          column: {
            grouping: false,
            shadow: false,
            borderWidth: 0
          }
        },
        series: [
          {
            name: 'Effort',
            color: 'rgba(165,170,217,1)',
            data: grit.effort ?? [],
            pointPadding: 0.3,
            pointPlacement: 0
          }, {
            name: 'Intrest',
            color: 'rgba(126,86,134,.9)',
            data: grit.intrest ?? [],
            pointPadding: 0.4,
            pointPlacement: 0
          }
        ]
      }
    );
  }, [grit]);
  // ==================================================
  // ==================================================
  return(
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />

      <Result
        result_text={"You currently view your overall mental performance as average"}
      />
    </div>
  );
};

export default Grit;